import { hooks } from "./hookactions"
import { actions } from "./actions"
export let SYSUserSettingsPassword = { hooks, actions }
